// Dados mockados para simulação
const MOCK_INVENTORY_STATS = {
    available: 126,
    reserved: 54,
    sold: 75,
    blocked: 45,
    total: 300
};

/**
 * Obtém estatísticas do inventário
 * @returns {Promise<Object>} Estatísticas de inventário
 */
export const getInventoryStats = async() => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));
    return MOCK_INVENTORY_STATS;
};

/**
 * Obtém unidades disponíveis para venda
 * @param {Object} filters - Filtros para busca
 * @returns {Promise<Array>} Lista de unidades
 */
export const getAvailableUnits = async(filters = {}) => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));

    // Implementar lógica de filtro aqui
    const units = [
        { id: 1, number: '1001', type: '2 quartos', area: '76m²', status: 'available', price: 65000, weekPrice: 780000, weeks: 12, floor: 10 },
        { id: 4, number: '1004', type: '2 quartos', area: '76m²', status: 'available', price: 65000, weekPrice: 780000, weeks: 12, floor: 10 },
        { id: 5, number: '1005', type: '3 quartos', area: '98m²', status: 'available', price: 89000, weekPrice: 1068000, weeks: 8, floor: 10 },
        { id: 7, number: '901', type: '2 quartos', area: '76m²', status: 'available', price: 62000, weekPrice: 744000, weeks: 10, floor: 9 }
    ];

    return units;
};

/**
 * Atualiza o status de uma unidade
 * @param {number} unitId - ID da unidade
 * @param {string} status - Novo status (available, reserved, sold, blocked)
 * @returns {Promise<Object>} Status da operação
 */
export const updateUnitStatus = async(unitId, status) => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));

    return {
        success: true,
        message: `Unidade ${unitId} atualizada para ${status}`
    };
};